<template>
  <div class="d-flex gap-2 align-items-end flex-wrap">
    <div style="min-width: 140px;">
      <select v-model="granularity" class="form-select">
        <option value="hour">Hourly</option>
        <option value="day">Daily</option>
        <option value="custom">Custom</option>
      </select>
    </div>

    <div class="flex-grow-1">
      <template v-if="granularity === 'hour'">
        <c-date class="form-control" v-model="dateRange.startDate" placeholder="" @input="onDateChange" />
      </template>
      <template v-else>
        <input-date-range
          v-model="dateRange"
          class="form-control"
          :single-date="granularity === 'hour'"
          @change="onDateChange"
        />
      </template>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import swal from 'sweetalert'
import { useQueryParamFilters } from '@codium/codium-vue'
import InputDateRange from '@/components/forms/InputDateRange'

export default {
  mixins: [useQueryParamFilters()],

  components: {
    InputDateRange
  },

  data () {
    return {
      granularity: 'day',
      dateRange: {
        startDate: dayjs().format('YYYY-MM-DD'),
        endDate: dayjs().add(6, 'days').format('YYYY-MM-DD')
      },
      filters: {
        startDate: null,
        endDate: null,
        granularity: 'day'
      },
      showRangeError: false
    }
  },
  watch: {
    dateRange: {
      async handler (date) {
        if (!date?.startDate || !date?.endDate) {
          await swal({
            title: 'Invalid date range.',
            text: 'Please set a valid date range.',
            buttons: {
              confirm: { text: 'Close' }
            }
          })
          return
        }

        this.filters.startDate = date?.startDate
        this.filters.endDate = date?.endDate
      },
      immediate: true
    },
    granularity (newVal) {
      if (newVal === 'hour') {
        const current = dayjs(this.dateRange.startDate || dayjs()).format('YYYY-MM-DD')
        this.dateRange = { startDate: current, endDate: current }
      } else {
        const sameDay = dayjs(this.dateRange.startDate).isSame(this.dateRange.endDate)
        if (sameDay) {
          const start = dayjs(this.dateRange.startDate || dayjs()).format('YYYY-MM-DD')
          const end = dayjs(start).add(6, 'days').format('YYYY-MM-DD')
          this.dateRange = { startDate: start, endDate: end }
        }
      }

      const params = {
        startDate: this.dateRange.startDate,
        endDate: this.dateRange.endDate,
        granularity: newVal
      }
      this.filters = { ...params }
      this.$emit('input', params)
    }
  },
  methods: {
    onDateChange (newValue) {
      if (newValue && typeof newValue === 'object' && (newValue.startDate || newValue.endDate)) {
        const start = newValue.startDate || this.dateRange.startDate
        const end = newValue.endDate || newValue.startDate || this.dateRange.endDate
        this.dateRange = { startDate: start, endDate: end }
      } else {
        const date = typeof newValue === 'string' ? newValue : dayjs(newValue).format('YYYY-MM-DD')
        this.dateRange = { startDate: date, endDate: date }
      }

      const params = {
        startDate: this.dateRange.startDate,
        endDate: this.dateRange.endDate,
        granularity: this.granularity
      }
      this.filters = { ...params }
      this.$emit('input', params)
    },
  }
}
</script>
